module.exports = __webpack_public_path__ + "img/help.786aa3dc.svg";